import React, {Component} from 'react';
import PropTypes from 'prop-types'
import {get} from '../../../server/actions';
import {Chart} from 'react-chartjs-2';
import Datetime from 'react-datetime'
import FusionCharts from 'fusioncharts';
import Charts from 'fusioncharts/fusioncharts.charts';
import ReactFC from 'react-fusioncharts';
import {BeatLoader} from 'react-spinners';
import moment from 'moment';

Charts(FusionCharts);

let allOrderedCount = 0,
    allNotOrderedCount = 0,
    allPaidCount = 0,
    allNotPaidCount = 0;


var converter = require('number-to-words');
let chartData = {};


let userInfo = ''
let schoolName = ''
let schoolId = ''

class ordersSnapshot extends Component {

    componentWillMount = () => {
        userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        if (userInfo) {
            schoolName = userInfo.schoolName;
        }
        schoolId = sessionStorage.getItem('SchoolId');
        new Promise((resolve => {
            this.setState({loading: true})
            this.getData(resolve)
        }))


    }
    renderInput = (props, openCalendar, closeCalendar) => {
        function clear() {
            props.onChange({target: {value: ''}});
        }

        return (
            <div>
                <input {...props} />
                <button className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i></button>
            </div>
        );
    }
    redirect = (e) => {// alert(e);

        try {

            this.context.router.history.push({
                pathname: '/schoolAdmin/viewOrdersGrid',
                params: {filter: 'Ordered', date: this.state.date}
            })
        } catch (error) {
            this.context.router.history.push('/schoolAdmin/viewOrdersGrid');
        }
    }

    setChartData = () => {
        let schoolId = sessionStorage.getItem('SchoolId');
        //alert(schoolId);
        let requests = new Promise((resolve) => {
            this.getData(resolve, schoolId);
        });

        Promise.resolve(requests).then(() => {
            this.setState({chartData: chartData});
        });
    }
    selectDate = (e) => {
        this.setState({date: new Date(e)}, () => {
            new Promise(resolve => {
                this.getData(resolve);
            });
        });

        this.refs.calendar.closeCalendar();
    }
    handleGradeChange = (evt) => {
        if (evt.target.value == 0) {
            this.setState({gradeName: parseInt(evt.target.value)}, () => this.setChartData())
        } else {
            this.setState({gradeName: evt.target.value}, () => this.setChartData())
        }

    };

    constructor() {
        super();
        let date = new Date();
        date.setMonth(date.getMonth())
        this.state = {
            studentData: [],
            date: date,
            drawChart: false,
            chartData: {
                labels: [
                    'NotOrdered',
                    'NotPaid',
                    'Paid',
                ],
                datasets: [{
                    data: [0, 0, 0],
                    backgroundColor: [
                        '#addd8e',
                        "#a6bddb",
                        '#fdbb84',
                    ],
                    hoverBackgroundColor: [
                        '#addd8e',
                        "#a6bddb",
                        '#fdbb84',
                    ]
                }]
            },
            gradeName: 0,
            allOrderedCount: 0,
            allNotOrderedCount: 0,
            allGradesPaidAmount: 0,
            allGradesNotPaidAmount: 0,
            orderedCountbyGrade: 0,
            notOrderedCountbyGrade: 0,
            paidAmountByGrade: 0,
            notPaidAmountByGrade: 0,
            loading: false
        }
    }

    getData(resolve) {

        let yearMonth = (moment(this.state.date,'MM').format().split('-')[0])+ '' + (moment(this.state.date,'MM').format().split('-')[1]);
        /*console.log('moment',moment(moment(this.state.date).add(1, 'month'),'MM').format().split('-')[0]);
        console.log('moment',moment(moment(this.state.date).add(1, 'month'),'MM').format().split('-')[1]);*/
        console.log(this.state.date);
        console.log('yearMonth',yearMonth);

        get('/reports/countByGrade?isVersion2=true&mealSchoolId=' + schoolId + '&yearMonth=' + yearMonth + '&schoolYear='+sessionStorage.getItem('schoolYearValue')+'&access_token=').then((response) => {
            this.setState({loading: true})
            console.log('get response', response);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            console.log('data', data);
            let studentData = data || {};
            this.setState({
                allGradesPaidAmount: studentData.paidOrdered.allGradesPaidAmount,
                allGradesNotPaidAmount: studentData.notPaidOrdered.allGradesNotPaidAmount,
                allOrderedCount: studentData.ordered.allGradesCount,
                allNotOrderedCount: studentData.notOrdered.allGradesCount,
                orderedCountbyGrade: studentData.ordered.countByGrades,
                notOrderedCountbyGrade: studentData.notOrdered.countByGrades,
                notPaidAmountByGrade: studentData.notPaidOrdered.notPaidAmountByGrades,
                paidAmountByGrade: studentData.paidOrdered.paidAmountByGrades,
                drawChart: true,
                loading: false
            }, () => resolve())
        }).catch(
            (error) => {
                resolve();
                this.setState({loading: false})
                console.log('Get School data response', error)

            }
        );

    }

    render() {

        let orderChartConfigs = {
            type: 'doughnut2d',
            width: 500,
            height: 400,
            dataFormat: 'json',
            overlayButton: {
                message: 'Grid',
                fontColor: '880000',
                bgColor: 'FFEEEE',
                borderColor: '660000'
            },
            dataSource: {
                "chart": {
                    "caption": schoolName,
                    "subcaption": "Order Summary",
                    "numberprefix": "",
                    "theme": "fint",
                    "rotateValues": "0",
                    "showLegend": "1",
                    "paletteColors": "#61A74F,#F47E35",
                    //"defaultCenterLabel": "Total Orders: 640",
                    "centerLabel": "$label: $value",
                    "showTooltip": "0",
                    "showPercentValues": "0",
                    "centerLabelBold": "1",
                    "dataEmptyMessage": "No data to display"

                },
                "data": [{
                    "label": "Ordered",
                    "value": this.state.allOrderedCount,
                    "link": "newchart-xml-Ordered"
                }, {
                    "label": "Not Ordered",
                    "value": this.state.allNotOrderedCount,
                    "link": "newchart-xml-notOrdered"
                },],
                "linkeddata": [{
                    "id": "Ordered",
                    "linkedchart": {
                        "chart": {
                            "caption": schoolName,
                            "subcaption": "Orders By Grade",
                            "numberprefix": "",
                            "theme": "fint",
                            "rotateValues": "0",
                            "plottooltext": "$label: $dataValue,  $percentValue",
                            "showTooltip": "0",
                            "showLegend": "1",
                            //"defaultCenterLabel": "Total Orders: 640",
                            "centerLabel": "$label: $value",
                            "showPercentValues": "0",
                            "centerLabelBold": "1",
                            "dataEmptyMessage": "No data to display"

                        },
                        data: [
                            {
                                label: 'Grade k',
                                value: this.state.orderedCountbyGrade.k,
                                link: "j-redirect-Ordered,k"
                            },
                            {
                                label: 'Grade 1',
                                value: this.state.orderedCountbyGrade.one,
                                link: "j-redirect-Ordered,one"
                            },
                            {
                                label: 'Grade 2',
                                value: this.state.orderedCountbyGrade.two,
                                link: "j-redirect-Ordered,two"
                            },
                            {
                                label: 'Grade 3',
                                value: this.state.orderedCountbyGrade.three,
                                link: "j-redirect-Ordered,three"
                            },
                            {
                                label: 'Grade 4',
                                value: this.state.orderedCountbyGrade.four,
                                link: "j-redirect-Ordered,four"
                            },
                            {
                                label: 'Grade 5',
                                value: this.state.orderedCountbyGrade.five,
                                link: "j-redirect-Ordered,five"
                            },
                            {
                                label: 'Grade 6',
                                value: this.state.orderedCountbyGrade.six,
                                link: "j-redirect-Ordered,six"
                            },
                            {
                                label: 'Grade 7',
                                value: this.state.orderedCountbyGrade.seven,
                                link: "j-redirect-Ordered,seven"
                            },
                            {
                                label: 'Grade 8',
                                value: this.state.orderedCountbyGrade.eight,
                                link: "j-redirect-Ordered,eight"
                            },
                            {
                                label: 'Grade 9',
                                value: this.state.orderedCountbyGrade.nine,
                                link: "j-redirect-Ordered,nine"
                            },
                            {
                                label: 'Grade 10',
                                value: this.state.orderedCountbyGrade.ten,
                                link: "j-redirect-Ordered,ten"
                            },
                            {
                                label: 'Grade 11',
                                value: this.state.orderedCountbyGrade.eleven,
                                link: "j-redirect-Ordered,eleven"
                            },
                            {
                                label: 'Grade 12',
                                value: this.state.orderedCountbyGrade.twelve,
                                link: "j-redirect-Ordered,twelve"
                            },
                        ],
                    }
                },
                    {
                        "id": "notOrdered",
                        "linkedchart": {
                            "chart": {
                                "caption": schoolName,
                                "subcaption": "Not Ordered By Grade",
                                "numberprefix": "",
                                "theme": "fint",
                                "rotateValues": "0",
                                "plottooltext": "$label: $dataValue,  $percentValue",
                                "showTooltip": "0",
                                "showLegend": "1",
                                //"defaultCenterLabel": "Total Orders: 640",
                                "centerLabel": "$label: $value",
                                "showPercentValues": "0",
                                "centerLabelBold": "1",
                                "dataEmptyMessage": "No data to display"
                            },
                            data: [
                                {
                                    label: 'Grade k',
                                    value: this.state.notOrderedCountbyGrade.k,
                                    link: "j-redirect-NotOrdered,k"
                                },
                                {
                                    label: 'Grade 1',
                                    value: this.state.notOrderedCountbyGrade.one,
                                    link: "j-redirect-NotOrdered,one"
                                },
                                {
                                    label: 'Grade 2',
                                    value: this.state.notOrderedCountbyGrade.two,
                                    link: "j-redirect-NotOrdered,two"
                                },
                                {
                                    label: 'Grade 3',
                                    value: this.state.notOrderedCountbyGrade.three,
                                    link: "j-redirect-NotOrdered,three"
                                },
                                {
                                    label: 'Grade 4',
                                    value: this.state.notOrderedCountbyGrade.four,
                                    link: "j-redirect-NotOrdered,four"
                                },
                                {
                                    label: 'Grade 5',
                                    value: this.state.notOrderedCountbyGrade.five,
                                    link: "j-redirect-NotOrdered,five"
                                },
                                {
                                    label: 'Grade 6',
                                    value: this.state.notOrderedCountbyGrade.six,
                                    link: "j-redirect-NotOrdered,six"
                                },
                                {
                                    label: 'Grade 7',
                                    value: this.state.notOrderedCountbyGrade.seven,
                                    link: "j-redirect-NotOrdered,seven"
                                },
                                {
                                    label: 'Grade 8',
                                    value: this.state.notOrderedCountbyGrade.eight,
                                    link: "j-redirect-NotOrdered,eight"
                                },
                                {
                                    label: 'Grade 9',
                                    value: this.state.notOrderedCountbyGrade.nine,
                                    link: "j-redirect-NotOrdered,nine"
                                },
                                {
                                    label: 'Grade 10',
                                    value: this.state.notOrderedCountbyGrade.ten,
                                    link: "j-redirect-NotOrdered,ten"
                                },
                                {
                                    label: 'Grade 11',
                                    value: this.state.notOrderedCountbyGrade.eleven,
                                    link: "j-redirect-NotOrdered,eleven"
                                },
                                {
                                    label: 'Grade 12',
                                    value: this.state.notOrderedCountbyGrade.twelve,
                                    link: "j-redirect-NotOrdered,twelve"
                                },
                            ]
                        }
                    }]
            },
            "events": {
                'dataplotClick': (evt, args) => {
                    console.log('evt', evt);
                    window.redirect = (e) => {
                        // alert('came');
                        console.log('this', this);
                        let arr = e.split(',');
                        console.log('elems', arr[0]);
                        // alert(arr[0]);
                        let filter = arr[1];
                        this.context.router.history.push({
                            pathname: '/schoolAdmin/viewOrdersGrid',
                            params: {filter: arr[0], grade: arr[1], date: this.state.date}
                        })
                        //window.location.replace('/schoolAdmin/viewOrdersGrid');
                        //this.props.history.replace('/schoolAdmin/viewOrdersGrid');
                    }

                    evt.sender.configureLink({
                        type: "doughnut2d",
                        overlayButton: {
                            message: 'back',
                            fontColor: '880000',
                            bgColor: 'FFEEEE',
                            borderColor: '660000'
                        }
                    }, 0);

                },
                'ready': (evt, args) => {
                    //alert('1')

                }
            }
        };

        let paymentChartConfigs = {
            type: 'doughnut2d',
            width: 500,
            height: 400,
            dataFormat: 'json',
            dataSource: {
                "chart": {
                    "caption": schoolName,
                    "subcaption": "Payment Summary",
                    "xaxisname": "Flavor",
                    "paletteColors": "#61A74F,#F47E35",
                    "yaxisname": "Amount (In USD)",
                    "numberprefix": "$",
                    "theme": "fint",
                    "rotateValues": "0",
                    "plottooltext": "$label, $dataValue,  $percentValue",
                    "showTooltip": "0",
                    "showLegend": "1",
                    //"defaultCenterLabel": "Total Orders: 640",
                    "centerLabel": "$label: $value",
                    "showPercentValues": "0",
                    "centerLabelBold": "1",
                    "dataEmptyMessage": "No data to display",
                    "renderErrorMessage": "No data to display"
                },

                "data": [{
                    "label": "Paid",
                    "value": this.state.allGradesPaidAmount,
                    "link": "newchart-xml-Paid"
                }, {
                    "label": "Not Paid",
                    "value": this.state.allGradesNotPaidAmount,
                    "link": "newchart-xml-NotPaid"
                },],
                "linkeddata": [{
                    "id": "Paid",
                    "linkedchart": {
                        "chart": {
                            "caption": schoolName,
                            "subcaption": "Paid Summary By Grade",
                            "numberprefix": "$",
                            "theme": "fint",
                            "rotateValues": "0",
                            "rotateValues": "0",
                            "plottooltext": "$label: $dataValue, $percentValue",
                            "showTooltip": "0",
                            "showLegend": "1",
                            //"defaultCenterLabel": "Total Orders: 640",
                            "centerLabel": "$label: $value",
                            "showPercentValues": "0",
                            "centerLabelBold": "1",
                            "dataEmptyMessage": "No data to display"
                        },
                        data: [
                            {
                                label: 'Grade k',
                                value: this.state.paidAmountByGrade.k,
                                link: "j-redirect-Paid,k"
                            },
                            {
                                label: 'Grade 1',
                                value: this.state.paidAmountByGrade.one,
                                link: "j-redirect-Paid,one"
                            },
                            {
                                label: 'Grade 2',
                                value: this.state.paidAmountByGrade.two,
                                link: "j-redirect-Paid,two"
                            },
                            {
                                label: 'Grade 3',
                                value: this.state.paidAmountByGrade.three,
                                link: "j-redirect-Paid,three"
                            },
                            {
                                label: 'Grade 4',
                                value: this.state.paidAmountByGrade.four,
                                link: "j-redirect-Paid,four"
                            },
                            {
                                label: 'Grade 5',
                                value: this.state.paidAmountByGrade.five,
                                link: "j-redirect-Paid,five"
                            },
                            {
                                label: 'Grade 6',
                                value: this.state.paidAmountByGrade.six,
                                link: "j-redirect-Paid,six"
                            },
                            {
                                label: 'Grade 7',
                                value: this.state.paidAmountByGrade.seven,
                                link: "j-redirect-Paid,seven"
                            },
                            {
                                label: 'Grade 8',
                                value: this.state.paidAmountByGrade.eight,
                                link: "j-redirect-Paid,eight"
                            },
                            {
                                label: 'Grade 9',
                                value: this.state.paidAmountByGrade.nine,
                                link: "j-redirect-Paid,nine"
                            },
                            {
                                label: 'Grade 10',
                                value: this.state.paidAmountByGrade.ten,
                                link: "j-redirect-Paid,ten"
                            },
                            {
                                label: 'Grade 11',
                                value: this.state.paidAmountByGrade.eleven,
                                link: "j-redirect-Paid,eleven"
                            },
                            {
                                label: 'Grade 12',
                                value: this.state.paidAmountByGrade.twelve,
                                link: "j-redirect-Paid,twelve"
                            },
                        ]
                    }
                }, {
                    "id": "NotPaid",
                    "linkedchart": {
                        "chart": {
                            "caption": schoolName,
                            "subcaption": "Not Paid Summary By Grade",
                            "numberprefix": "$",
                            "theme": "fint",
                            "rotateValues": "0",
                            "rotateValues": "0",
                            "plottooltext": "$label, $dataValue,  $percentValue",
                            "showTooltip": "0",
                            "showLegend": "1",
                            //"defaultCenterLabel": "Total Orders: 640",
                            "centerLabel": "$label: $value",
                            "showPercentValues": "0",
                            "centerLabelBold": "1",
                            "dataEmptyMessage": "No data to display"
                        },
                        data: [
                            {
                                label: 'Grade k',
                                value: this.state.notPaidAmountByGrade.k,
                                link: "j-redirect-NotPaid,k"
                            },
                            {
                                label: 'Grade 1',
                                value: this.state.notPaidAmountByGrade.one,
                                link: "j-redirect-NotPaid,one"
                            },
                            {
                                label: 'Grade 2',
                                value: this.state.notPaidAmountByGrade.two,
                                link: "j-redirect-NotPaid,two"
                            },
                            {
                                label: 'Grade 3',
                                value: this.state.notPaidAmountByGrade.three,
                                link: "j-redirect-NotPaid,three"
                            },
                            {
                                label: 'Grade 4',
                                value: this.state.notPaidAmountByGrade.four,
                                link: "j-redirect-NotPaid,four"
                            },
                            {
                                label: 'Grade 5',
                                value: this.state.notPaidAmountByGrade.five,
                                link: "j-redirect-NotPaid,five"
                            },
                            {
                                label: 'Grade 6',
                                value: this.state.notPaidAmountByGrade.six,
                                link: "j-redirect-NotPaid,six"
                            },
                            {
                                label: 'Grade 7',
                                value: this.state.notPaidAmountByGrade.seven,
                                link: "j-redirect-NotPaid,seven"
                            },
                            {
                                label: 'Grade 8',
                                value: this.state.notPaidAmountByGrade.eight,
                                link: "j-redirect-NotPaid,eight"
                            },
                            {
                                label: 'Grade 9',
                                value: this.state.notPaidAmountByGrade.nine,
                                link: "j-redirect-NotPaid,nine"
                            },
                            {
                                label: 'Grade 10',
                                value: this.state.notPaidAmountByGrade.ten,
                                link: "j-redirect-NotPaid,ten"
                            },
                            {
                                label: 'Grade 11',
                                value: this.state.notPaidAmountByGrade.eleven,
                                link: "j-redirect-NotPaid,eleven"
                            },
                            {
                                label: 'Grade 12',
                                value: this.state.notPaidAmountByGrade.twelve,
                                link: "j-redirect-NotPaid,twelve"
                            },
                        ]
                    }
                }]
            },
            "events": {
                'dataplotClick': (evt, args) => {
                    console.log('evt', evt);
                    window.redirect = (e) => {
                        console.log('this', this);
                        let arr = e.split(',');
                        console.log('elems', arr[0]);
                        // alert(arr[0]);
                        let filter = arr[0];
                        this.context.router.history.push({
                            pathname: '/schoolAdmin/viewOrdersGrid',
                            params: {filter: arr[0], grade: arr[1], date: this.state.date}
                        })
                    }
                    evt.sender.configureLink({
                        type: "doughnut2d",
                        overlayButton: {
                            message: 'back',
                            fontColor: '880000',
                            bgColor: 'FFEEEE',
                            borderColor: '660000'
                        }
                    }, 0);

                }
            }
        };

        console.log('all paid', this.state.allPaidCount);
        console.log('all paid', this.state.allNotPaidCount);
        console.log('date', this.state.date);


        return (
            <section className="full-width clearfix margin-top">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12 col-centered createmenu-panel">
                            <div className="panel panel-primary">
                                <div className="panel-heading text-center"><h3 className="panel-title"> Order
                                    Summary </h3>
                                </div>
                                <div className="panel-body">
                                    <div className='sweet-loading'
                                         style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                                        <BeatLoader
                                            size={20}
                                            color={'#ea7066'}
                                            loading={this.state.loading}
                                        />
                                    </div>
                                    <div>
                                        <div className="uploadFileInfo col-md-12 col-xs-12"
                                             style={{margin: '0px 8px 8px -11px'}}>
                                            <label className="custom-label col-sm-10 text-right col-xs-6">Select
                                                Month:</label>
                                            <div className="input-group col-sm-2 pull-right col-xs-6">
                                                <Datetime ref='calendar' dateFormat="MMMM-YYYY" timeFormat={false}
                                                          closeOnSelect={true}
                                                          defaultValue={this.state.date}
                                                          viewMode='months'
                                                          onChange={this.selectDate}
                                                          renderInput={this.renderInput}/>
                                            </div>
                                        </div>

                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center">
                                            {this.state.drawChart && (this.state.allOrderedCount !== 0 || this.state.allNotOrderedCount !== 0) ?
                                                <ReactFC {...orderChartConfigs} /> :
                                                <div> {() => this.setState({loading: true})} <ReactFC type='doughnut2d'
                                                                                                      dataEmptyMessage="No order data to display chart"/>
                                                </div>}
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center">
                                            {this.state.drawChart && (this.state.allGradesPaidAmount !== 0 || this.state.allGradesNotPaidAmount !== 0) ?
                                                <ReactFC {...paymentChartConfigs} /> :
                                                <div> {() => this.setState({loading: true})} <ReactFC type='doughnut2d'
                                                                                                      dataEmptyMessage="No payment data to display chart"
                                                /></div>}
                                        </div>

                                        <div className="priceLower pull-right"
                                             style={{marginRight: "26px", marginTop: "15px"}}>
                                            <ul className="list-unstyled priceOffer">
                                                <li><a href="javascript:void(0);" onClick={this.redirect}
                                                       className="color-3"><strong> View Grid</strong></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </section>
                );
                }
                }

                ordersSnapshot.contextTypes = {
                router: PropTypes.object.isRequired
            }

                export default ordersSnapshot;



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/ordersGraph.jsx